module.exports = __webpack_public_path__ + "img/map.39fe2cf6.png";